import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ReviewProviderForm = forwardRef(({provider, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={provider}
      type="provider"
      fieldsComponent={Fields}
      onSave={(update) => services.reviewProvider.saveProvider(update)}
      onSaved={onSaved}
    />
  );
});

export default ReviewProviderForm;
